
    var riot = require('riot')
    riot.tag2('footer-tpl', '<div class="to_top"> <a data-target="#" class="js-trigger" data-mt-duration="300" data-mt-easing="easeOutQuad">ページ上部へ ▲ </a> </div> <footer> <div class="address"> <img src="images/top/logo_text.png"> <div class="desc"> <p>〒849-2305</p> <p>佐賀県武雄市山内町大字宮野1426−1</p> <p><a href="tel:0954452234"><img src="images/icon/tel.svg" class="telephone">0954-45-2234</a></p> </div> </div> <small>@2018 房 空路 all rights reserved</small> </footer>', '', '', function(opts) {
});
    
  